"use client"
import { styled } from "styled-components"

export const DropdownMenuContainer = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: var(--z-index-dropdown-menu);
`

export const DropdownMenuWrapper = styled.div`
  app-region: none;
  min-width: 210px;
  max-width: 800px;
  max-height: calc(100vh - 32px);
  border-radius: 8px;
  border: 1px solid
    var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: var(--Schemes-Surface-Surface-Container-Lowest, #fff);
  /* Shadow/lg */
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, 0.08),
    0 4px 6px -2px rgba(16, 24, 40, 0.03);

  overflow: hidden;
`

export const StyledDropdownMenuItem = styled.div<{
  $disabled?: boolean
  $isSelected?: boolean
  $isClearOption?: boolean
}>`
  display: flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: var(--radius-m);
  color: var(--text-contr-default);

  border-bottom: ${(props) =>
    props.$isClearOption
      ? "0.5px solid var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14))"
      : "none"};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};

  @supports (-webkit-touch-callout: none) {
    border-bottom: ${(props) =>
      props.$isClearOption
        ? "1px solid var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14))"
        : "none"};
  }

  opacity: ${(props) => (props.$disabled ? "0.5" : "1")};

  &:hover {
    background: ${(props) =>
      props.$disabled
        ? "transparent"
        : props.$isSelected
        ? "rgba(13, 163, 186, 0.08)"
        : "var(--Schemes-Surface-Surface-Container-Lowest, #fff)"};
  }

  &:first-child {
    border-top: none;
  }

  background: ${(props) =>
    props.$isSelected
      ? "rgba(13, 163, 186, 0.08)"
      : "var(--Schemes-Surface-Surface-Container-Lowest, #fff)"};
`

export const DropdownMenuItemLabel = styled.div`
  color: var(--Schemes-Surface-On-surface-On-Surface, #1c1f21);
  font-size: 16px;
  line-height: 160%;
  cursor: default;
`

export const StyledDropdownMenuItemDetailTrailing = styled.span`
  margin-left: 8px;
  flex: 1 1 0%;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-contr-detail);
`

export const DropdownMenuGroup = styled.div``

export const DropdownMenuItemStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--object-contr-active);
  margin-left: auto;
  flex-shrink: 0;
`
